<template>
        <vuejs-datepicker :id="id" input-class="form-control datepicker" :format="customFormat" :language="ru"
                          :value="value"
                          @selected="selectedHandle"
                          @closed="closeHandler"
                          @opened="openHandler"
                          @blur="$emit('blur')"
        ></vuejs-datepicker>
</template>

<script>
    import vuejsDatepicker from '../../common/fields/vuejs-datepicker/src/components/Datepicker';
    import {ru} from 'vuejs-datepicker/dist/locale'

    //import vuejsDatepicker from "vuejs-datepicker"
    //import {ru} from 'vuejs-datepicker'

    import moment from 'moment'

    export default {
        name: 'date-field',
        components: {vuejsDatepicker},
        props: {
            id: String,
            value: [Date, String, Object]
        },
        data() {
            return {
                ru: ru
            }
        },
        methods: {
            customFormat(date) {
                return moment(date).format('DD/MM/YYYY');
            },
            selectedHandle(e) {
                //console.log('input')
                this.$emit('input', e);
            },
            openHandler() {
                //console.log('focus')
                this.$emit('focus')
            },
            closeHandler() {
                //console.log('blur')
                this.$emit('blur');
            },
        },
    }
</script>


<style scoped>

</style>
